angular.module('directives.dashboard').controller('wgtSettingsBusinessArea',
    ['$scope', '$rootScope', 'BusinessAreasApiService',
        function ($scope, $rootScope, BusinessAreasApiService) {
            $scope.businessAreas = [];
            if ($scope.item.setting === undefined || $scope.item.setting === null ) {
                $scope.selectedSettingItem = '';
                $scope.selectedBusinessArea = undefined;
                $scope.selectedWidgetTimeFrame = "0";
            } else {    
                $scope.selectedSettingItem = parseInt($scope.item.setting);
                if(isNaN($scope.selectedSettingItem)){
                    var parsedSettings = JSON.parse($scope.item.setting);
                    $scope.selectedSettingItem = parsedSettings.locationIds ? parsedSettings.locationIds[0] : '';
                    $scope.selectedBusinessAreaId = parsedSettings.businessAreaId ? parsedSettings.businessAreaId : 0;
                    $scope.selectedWidgetTimeFrame = parsedSettings.selectedWidgetTimeFrame ? parsedSettings.selectedWidgetTimeFrame.toString(): "0"
                }
            }
            BusinessAreasApiService.getBusinessAreas().then(function (response){
                $scope.businessAreas = response;
                if($scope.selectedBusinessAreaId && $scope.selectedBusinessAreaId !== 0){
                    $scope.selectedBusinessArea = $scope.businessAreas.filter(x => x.id === $scope.selectedBusinessAreaId)[0];
                }
            });
            $scope.saveSettings = function () {
                if ($scope.selectedSettingItem === null || $scope.selectedSettingItem === "" ) {
                    $scope.$parent.selectedLocation = '';
                    $scope.$parent.selectedLocationNumber = '';
                    $scope.$parent.selectedLocationId = 0;
                    $scope.$parent.selectedBusinessArea = $scope.selectedBusinessArea;
                    $scope.$parent.selectedBusinessAreaId = $scope.selectedBusinessArea && $scope.selectedBusinessArea.id > 0 ? $scope.selectedBusinessArea.id : undefined;
                    $scope.selectedSettingItem = {};
                    if($scope.selectedBusinessArea){
                        $scope.$parent.selectedBusinessArea = $scope.selectedBusinessArea;
                        $scope.selectedSettingItem.businessAreaId = $scope.selectedBusinessArea.id;
                    }
                    $scope.$parent.selectedWidgetTimeFrame = $scope.selectedWidgetTimeFrame ? parseInt($scope.selectedWidgetTimeFrame) : 0;
                    if($scope.selectedWidgetTimeFrame){
                        $scope.selectedSettingItem.selectedWidgetTimeFrame = parseInt($scope.selectedWidgetTimeFrame);
                    }
                } else {
                    var location = $.grep($scope.currentUser.locations, function (e) {
                        return e.id === $scope.selectedSettingItem;
                    })[0];
                    $scope.$parent.selectedLocation = location.locationName;
                    $scope.$parent.selectedLocationNumber = location.locationNumber;
                    $scope.$parent.selectedLocationId = location.id;
                    $scope.$parent.selectedBusinessArea = $scope.selectedBusinessArea;
                    $scope.$parent.selectedBusinessAreaId = $scope.selectedBusinessArea && $scope.selectedBusinessArea.id > 0 ? $scope.selectedBusinessArea.id : undefined;
                    $scope.$parent.selectedWidgetTimeFrame =  $scope.selectedWidgetTimeFrame ? parseInt($scope.selectedWidgetTimeFrame) : 0

                    $scope.selectedSettingItem = {
                        locationIds: [angular.copy(location.id)], 
                        businessAreaId: $scope.selectedBusinessArea && $scope.selectedBusinessArea.id > 0 ? $scope.selectedBusinessArea.id : undefined, 
                        selectedWidgetTimeFrame: parseInt($scope.$parent.selectedWidgetTimeFrame)
                    };
                }
                $scope.item.setting = $scope.selectedSettingItem;
                if ($scope.$parent) {
                    if ($scope.$parent.loadWidget) {
                        $scope.$parent.loadWidget();
                    }
                }
                $rootScope.$emit("widget.changed", $scope.item);

                $scope.$close();
            };
        }]);
